import React from 'react'
import PropTypes from 'prop-types'

function Button (props) {
  const {
    color = 'primary',
    type = 'button',
    onClick = null,
    text = null,
    disabled = false,
    fullWidth = false,
    children,
    className
  } = props

  const colorsMap = {
    primary: 'btn-primary',
    white: 'btn-white',
    lightgray: 'btn-lightgray',
    green: 'btn-green',
    red: 'btn-red',
    outlinePrimary: 'btn-outlinePrimary',
    outlineDark: 'btn-outlineDark',
    outlineWhite: 'btn-outlineWhite',
    outlineLight: 'btn-outlineLight',
    outlineRed: 'btn-outlineRed'
  }

  const handleOnClick = (e) => {
    if (typeof onClick === 'function' && disabled !== true) {
      onClick(e)
    }
  }

  const classList = [
    'btn',
    colorsMap[color],
    disabled ? 'btn-disabled' : null,
    fullWidth ? 'btn-full' : null,
    className
  ].filter(c => c).join(' ')

  return (
    <button
      disabled={disabled}
      type={type}
      onClick={(e) => handleOnClick(e)}
      className={classList}
    >
      {text || children}
    </button>
  )
}

Button.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string,
  type: PropTypes.oneOf(['submit', 'button']),
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  color: PropTypes.oneOf([
    'primary',
    'white',
    'lightgray',
    'green',
    'red',
    'outlinePrimary',
    'outlineDark',
    'outlineWhite',
    'outlineLight',
    'outlineRed'
  ])
}

export default Button
